import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tab,
  Tabs,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  ShowAllCoordinators,
  ShowAllUsers,
  deleteUser,
} from "../../../../context/Slice/RegisterSlice";
import Swal from "sweetalert2";
import "./UserManagement.css";

const UserManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allUsers = useSelector((state) => state.RegisterR.AlluserData);
  const coordinators = useSelector(
    (state) => state.RegisterR.coordinators.coordinatorRole
  );

  const [rows, setRows] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isDisable, setIsDisable] = useState(true);
  const [filterStatus, setFilterStatus] = useState("all"); // 'all', 'active', 'inactive'
  const [tabValue, setTabValue] = useState("active");

  useEffect(() => {
    dispatch(ShowAllUsers());
    dispatch(ShowAllCoordinators());
  }, [dispatch]);

  console.log(coordinators)
  console.log(allUsers)

  useEffect(() => {
    if (Array.isArray(allUsers) && Array.isArray(coordinators)) {
      const filteredUsers = allUsers
        .filter((user) => user.role === "user")
        .filter((user) => user.status === tabValue) // Filter by "active" or "inactive"
        .map((user) => {
          const coordinator = coordinators?.find((c) => c?.id === user?.id);
          console.log(coordinator)
          const OwnerCity = coordinator?.Coordinator?.[0]?.City || "N/A";
          console.log(OwnerCity)
          return { ...user, OwnerCity };
        });
      // console.log(filteredUsers)
      setRows(filteredUsers); // Set pre-filtered rows
    }
  }, [allUsers, coordinators, tabValue]); // Depend on tabValue only

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue); // Directly set to "active" or "inactive"
  };

  // Combine search and status filtering
  const filteredRows = rows.filter((row) => {
    const matchesFilter =
      filterStatus === "all" ||
      (filterStatus === "active" && row.status === "active") ||
      (filterStatus === "inactive" && row.status === "inactive");

    const matchesSearch =
      row.firstName?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.lastName?.toLowerCase().includes(searchText.toLowerCase()) ||
      row.email?.toLowerCase().includes(searchText.toLowerCase());

    return matchesFilter && matchesSearch;
  });

  const handleDelete = (id, currentStatus) => {
    const isCurrentlyActive = currentStatus === "active";
    const actionText = isCurrentlyActive ? "Disable" : "Enable";
    const confirmButtonText = `Yes, ${actionText} it!`;
    const successMessage = `The Vendor has been ${
      isCurrentlyActive ? "disabled" : "enabled"
    }.`;

    Swal.fire({
      title: "Are you sure?",
      text: `${actionText} the Vendor data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: confirmButtonText,
      customClass: {
        popup: "swal2-popup",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteUser(id)).then(() => {
          Swal.fire(`${actionText}d!`, successMessage, "success");
          dispatch(ShowAllUsers()); // Refresh the vendor list
        });
      }
    });
  };

  const handleView = (user) => {
    setSelectedUser(user);
  };

  const handleClose = () => {
    setSelectedUser(null);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 60 },
    { field: "firstName", headerName: "First Name", width: 150 },
    { field: "lastName", headerName: "Last Name", width: 150 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "role", headerName: "Role", width: 150 },
    { field: "mobile_number", headerName: "Mobile", width: 150 },
    // {
    //   field: "OwnerCity",
    //   headerName: "City",
    //   width: 150,
    //   renderCell: (params) => <p>{params.row.OwnerCity || "N/A"}</p>,
    // },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <div>
          <Button
            variant="contained"
            className="fs-5"
            sx={{ marginRight: "8px" }}
            onClick={() => handleView(params.row)}
          >
            View
          </Button>
          <Button
            variant="contained"
            className="fs-5"
            color={params.row.status === "active" ? "error" : "success"}
            onClick={() => handleDelete(params.row.id, params.row.status)} // Correctly passing status
          >
            {params.row.status === "active" ? "Disable" : "Enable"}
          </Button>
        </div>
      ),
    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const HandleBack = () => {
    navigate("/admin-dashboard");
  };

  return (
    <React.Fragment>
      <Box sx={{ height: 400, width: "100%" }} id="Admin-Usermanagement" className="data-grid-container">
        {/* Back Button */}
        <Button
          variant="contained"
          color="secondary"
          onClick={HandleBack}
          sx={{ position: "absolute", top: "20px", left: "20px" }}
        >
          Back
        </Button>
        <h2 className="heading">User Management</h2>
        <div className="searchField">
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            className="searchInput"
          />
        </div>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="status tabs"
          >
            <Tab label="Active Users" value="active" />
            <Tab label="Inactive Users" value="inactive" />
          </Tabs>
        </Box>

        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          pageSizeOptions={[5, 10, 15]}
          checkboxSelection
          disableRowSelectionOnClick
          components={{ Toolbar: CustomToolbar }}
          sx={{
            "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
              fontSize: "14px",  // Default font size for larger screens
            },
            "@media (max-width: 800px)": {
              "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                fontSize: "12px",  // Font size for smaller screens
              },
              "& .MuiDataGrid-cell": {
                padding: "5px",  // Reduce padding for smaller screens to make cells more compact
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "12px",  // Ensure column header title is also reduced
              },
            },
            "@media (max-width: 500px)": {
              "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                fontSize: "12px",  // Further reduce font size for very small screens
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontSize: "12px",  // Reduce column header title font size
              },
              "& .MuiDataGrid-cell": {
                padding: "1px",  // Reduce padding even more for very small screens
              },
            },
          }}
        />
      </Box>

      {/* Popup Modal */}
      <Dialog
        open={!!selectedUser}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>User Details</DialogTitle>
        <DialogContent>
          {selectedUser && (
            <div>
              <p>
                <strong>ID:</strong> {selectedUser.id}
              </p>
              <p>
                <strong>Name:</strong> {selectedUser.firstName}{" "}
                {selectedUser.lastName}
              </p>
              <p>
                <strong>Email:</strong> {selectedUser.email}
              </p>
              <p>
                <strong>Role:</strong> {selectedUser.role}
              </p>
              <p>
                <strong>Mobile:</strong> {selectedUser.mobile_number}
              </p>
              <p>
                {/* <strong>City:</strong> {selectedUser.OwnerCity || "N/A"} */}
              </p>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default UserManagement;
